/**
 * 영유아 표준예방접종 일정 — 명세서 §5.11 / §5.13.
 *
 * 보편 종이 생활기록부의 표준예방접종표와 같은 구성이다(질병관리청 예방접종 도우미 기준).
 * 앱의 접종 이력 화면과 생활기록부 PDF의 ④표준예방접종 표가 이 정의를 함께 쓴다 —
 * DB에는 코드(vaccineCode·doseLabel)만 저장하고 표기는 여기서 붙인다.
 */
/** 기타 임시예방접종 — 백신 이름을 직접 적는 자유 항목 */
export const VACCINE_ETC_CODE = 'ETC';
export const VACCINE_SCHEDULE = [
    { disease: '결핵', vaccines: [{ code: 'BCG', name: 'BCG(피내용)', doses: ['1회'] }] },
    { disease: 'B형 간염', vaccines: [{ code: 'HEPB', name: 'HepB', doses: ['1차', '2차', '3차'] }] },
    {
        disease: '디프테리아·파상풍·백일해',
        vaccines: [{ code: 'DTAP', name: 'DTaP', doses: ['1차', '2차', '3차', '4차(추가)'] }],
    },
    { disease: '폴리오', vaccines: [{ code: 'IPV', name: 'IPV', doses: ['1차', '2차', '3차'] }] },
    {
        disease: 'b형헤모필루스 인플루엔자',
        vaccines: [{ code: 'HIB', name: 'Hib', doses: ['1차', '2차', '3차', '4차'] }],
    },
    { disease: '홍역·유행성이하선염·풍진', vaccines: [{ code: 'MMR', name: 'MMR', doses: ['1차'] }] },
    { disease: '수두', vaccines: [{ code: 'VAR', name: 'Var', doses: ['1회'] }] },
    {
        disease: '일본뇌염',
        vaccines: [
            { code: 'JEV_INACT', name: 'JEV(사백신)', doses: ['1차', '2차', '3차'] },
            { code: 'JEV_LIVE', name: 'JEV(생백신)', doses: ['1차', '2차'] },
        ],
    },
    {
        disease: '인플루엔자',
        vaccines: [{ code: 'FLU', name: 'Flu', doses: ['매년 접종'], repeatable: true }],
    },
    {
        disease: '장티푸스(24개월 이상부터)',
        vaccines: [{ code: 'TYPHOID', name: '주사용', doses: ['고위험군에 한함'] }],
    },
    { disease: 'A형 간염', vaccines: [{ code: 'HEPA', name: 'HepA', doses: ['1차', '2차'] }] },
    {
        disease: '폐렴구균',
        vaccines: [
            { code: 'PCV', name: 'PCV(단백결합)', doses: ['1차', '2차', '3차', '4차'] },
            { code: 'PPSV', name: 'PPSV(다당질)', doses: ['고위험군에 한함'] },
        ],
    },
    {
        disease: '기타 임시예방접종 등',
        vaccines: [{ code: VACCINE_ETC_CODE, name: '', doses: ['명칭 기재', '명칭 기재'], repeatable: true }],
    },
];
export function findVaccine(code) {
    for (const group of VACCINE_SCHEDULE) {
        const vaccine = group.vaccines.find((v) => v.code === code);
        if (vaccine)
            return vaccine;
    }
    return undefined;
}
/** 병력기록(§5.13 ⑤)의 입소 전/후 구분 */
export const ILLNESS_PHASES = ['BEFORE_ADMISSION', 'AFTER_ADMISSION'];
export const ILLNESS_PHASE_LABELS = {
    BEFORE_ADMISSION: '입소 전',
    AFTER_ADMISSION: '입소 후',
};
//# sourceMappingURL=vaccinations.js.map